module.exports = __webpack_public_path__ + "img/T4-C-rc_12.f116fb36.png";